
(function () {
    try {
        let tlYMALClone;
        let overrideInstalled = false;

        const getProductHandleFromPath = () => {
            const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
            return match ? decodeURIComponent(match[1]) : null;
        };

        const getCurrentProductId = () => {
            const currentHandle = getProductHandleFromPath();
            const objectCandidates = [
                {
                    id: window?.ShopifyAnalytics?.meta?.product?.id,
                    handle: window?.ShopifyAnalytics?.meta?.product?.handle
                },
                {
                    id: window?.meta?.product?.id,
                    handle: window?.meta?.product?.handle
                }
            ];
            for (const candidate of objectCandidates) {
                if (!candidate?.id) continue;
                if (!currentHandle || !candidate.handle || candidate.handle === currentHandle) {
                    return String(candidate.id);
                }
            }
            const scopedSelectors = [
                'main form[action*="/cart/add"] input[name="product-id"]',
                '#MainContent form[action*="/cart/add"] input[name="product-id"]',
                'product-info form[action*="/cart/add"] input[name="product-id"]',
                '.product form[action*="/cart/add"] input[name="product-id"]',
                'main [data-product-id]',
                '#MainContent [data-product-id]'
            ];
            for (const selector of scopedSelectors) {
                const element = document.querySelector(selector);
                const value = element?.value || element?.getAttribute?.("data-product-id");
                if (value) {
                    return String(value);
                }
            }
            return null;
        };

        const installOverride = (ymalInstance) => {
            if (!ymalInstance || overrideInstalled) return;
            const originalCheckCartData = ymalInstance.checkCartData?.bind(ymalInstance);
            if (!originalCheckCartData) return;
            overrideInstalled = true;

            ymalInstance.checkCartData = async () => {
                const cartData = await originalCheckCartData();
                if (ymalInstance.template !== "product") {
                    return cartData;
                }
                const currentProductId = getCurrentProductId();
                if (!currentProductId) {
                    return cartData;
                }
                const existing = cartData.productInCart || [];
                return {
                    ...cartData,
                    productInCart: Array.from(new Set([...existing, currentProductId]))
                };
            };

            setTimeout(() => {
                if (ymalInstance.template === "product") {
                    ymalInstance.checkApplyOffer?.();
                }
            }, 0);
        };

        // Hook đối tượng window.tlYMAL ngay khi được khởi tạo
        Object.defineProperty(window, "tlYMAL", {
            configurable: true,
            enumerable: true,
            get() {
                return tlYMALClone;
            },
            set(value) {
                tlYMALClone = value;
                installOverride(value);
            }
        });

        if (window.tlYMAL) {
            installOverride(window.tlYMAL);
        }

        // Bổ sung lắng nghe AJAX Add to Cart an toàn cho Theme Alchemy
        if (window.XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.open) {
            const originalOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function (method, url, async) {
                try {
                    if (url && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
                        this.addEventListener('readystatechange', function () {
                            if (this.readyState === 4 && window.tlYMAL && typeof window.tlYMAL.checkApplyOffer === 'function') {
                                window.tlYMAL.checkApplyOffer();
                            }
                        });
                    }
                } catch (e) {}
                return originalOpen.apply(this, arguments);
            };
        }
    } catch (err) {
        console.warn('[Salepify YMAL Patch] Setup error:', err);
    }
})();
